import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { useScript } from '../Utils';
import Tooltip from '../Tooltip';

const ShareToGoogleClassroom = ({ ...props }) => {
  useScript('https://apis.google.com/js/platform.js');

  return (
    <Tooltip
      interactive
      content={I18n.t('share_to_google_classroom')}
      distance={25}
      flip={false}
      size="medium"
    >
      <span className={`share-to-google-classroom ${props.className}`}>
        <div className="g-sharetoclassroom" data-size="32" data-url={props.url} />
      </span>
    </Tooltip>
  );
};

ShareToGoogleClassroom.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired
};

ShareToGoogleClassroom.defaultProps = {
  className: ''
};

export default ShareToGoogleClassroom;
